import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import TableDropdownAndPagination from "../../../services/TableDropdownAndPagination";
import { convertToOriginalForm } from "../../../services/StringOperation";
import './AppliedJobsList.css'
import { TableLoader } from "../SkeletonLoader/TableLoader";
import ExportButtons from "../SkeletonLoader/ExportButtons";
import TableNewPaginanation from "../../../services/TableNewPaginanation";

const AppliedJobsList = ({ jobTypeParam, ...props }) => {
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [recordLen, setRecordLen] = useState(10);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [dataLen, setDataLen] = useState(0);
  const [filter, setFilter] = useState("");
  const [spinLoader, setSpinLoader] = useState(true);
  const [inputValue, setInputValue] = useState("");
  // paginatation
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // useEffect(() => {
  //   const filteredJobs = props.appliedjobs.filter(
  //     (job) =>
  //       job.cnd_permanent_job_status ===
  //       (jobTypeParam ? jobTypeParam : "Applied")
  //   );
  //   setDataLen(filteredJobs.length);
  //   setAppliedJobs(filteredJobs);
  // }, [props.appliedjobs]);

  useEffect(() => {
  if (props.appliedjobs && props.appliedjobs.length > 0) {
    const filteredJobs = props.appliedjobs.filter(
      (job) =>
        job.cnd_permanent_job_status ===
        (jobTypeParam ? jobTypeParam : "Applied")
    );

    setAppliedJobs(filteredJobs);
    setDataLen(filteredJobs.length);
    setSpinLoader(false); // 
  } else {
    setSpinLoader(false);
  }
}, [props.appliedjobs, jobTypeParam]);


  let totalPages = Math.ceil(dataLen / recordsPerPage);

  const handleLeft = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleRight = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const visiblePages = 4;

  // const renderPageNumbers = () => {
  //   const pageNumbers = [];
  //   let startPage = currentPage - Math.floor(visiblePages / 2);
  //   let endPage = currentPage + Math.floor(visiblePages / 2);

  //   if (startPage < 1) {
  //     startPage = 1;
  //     endPage = Math.min(totalPages, visiblePages);
  //   }

  //   if (endPage > totalPages) {
  //     endPage = totalPages;
  //     startPage = Math.max(1, totalPages - visiblePages + 1);
  //   }

  //   for (let i = startPage; i <= endPage; i++) {
  //     pageNumbers.push(
  //       <li
  //         key={i}
  //         className={i === currentPage ? "active" : ""}
  //         onClick={() => {
  //           setCurrentPage(i);
  //           setFilter("");
  //         }}
  //       >
  //         <Link to="#">{i}</Link>
  //       </li>
  //     );
  //   }

  //   return pageNumbers;
  // };

  // const handleDropDown = (value) => {
  //   setRecordLen(value);
  //   setRecordsPerPage(value);
  //   setCurrentPage(1);
  // };

  const matchesSearchText = (job) => {
    const searchText = inputValue.toLowerCase();
    return (
      job.users_firstname.toLowerCase().includes(searchText) ||
      job.users_lastname.toLowerCase().includes(searchText) ||
      job.cnd_permanent_job_title.toLowerCase().includes(searchText) ||
      job.cnd_permanent_job_status.toLowerCase().includes(searchText) ||
      format(new Date(job.cnd_permanent_job_created_date), "dd-MM-yyyy")
        .toLowerCase()
        .includes(searchText)
    );
  };

  // search filter
  const filteredJobs = appliedJobs ? appliedJobs.filter(matchesSearchText) : [];

  // pagination indexes (NEW reusable component compatible)
  const startIndex = pageSize === "all" ? 0 : (currentPage - 1) * pageSize;

  const endIndex =
    pageSize === "all"
      ? filteredJobs.length
      : Math.min(startIndex + pageSize, filteredJobs.length);

  //   const showPagination =
  // pageSize !== "all" && filteredJobs.length > pageSize;


  const prepareAppliedJobsExportData = (data) => {
  if (!data || data.length === 0) return [];

  return data.map((job, index) => ({
    "Sr.No": index + 1,
    Date: job.cnd_permanent_job_created_date
      ? format(
          new Date(job.cnd_permanent_job_created_date),
          "dd-MM-yyyy"
        )
      : "-",
    Name: `${job.users_firstname || ""} ${job.users_lastname || ""}`,
    "Job Title": job.cnd_permanent_job_title
      ? convertToOriginalForm(job.cnd_permanent_job_title)
      : "-",
    Status: job.cnd_permanent_job_status || "-"
  }));
};

const exportData = React.useMemo(() => {
  return prepareAppliedJobsExportData(filteredJobs);
}, [filteredJobs]);


  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        <div className="container">
<div className="row align-items-center mb-3">

  
  <div className="col-sm-6 d-flex align-items-center">
    {/* <ExportButtons
      data={exportData}
      fileName="Applied_Jobs_List"
      buttons={true} 
    /> */}
  </div>

  {/* RIGHT – Search */}
  <div className="col-sm-6 d-flex justify-content-end">
    <input
      type="text"
      id="search"
      name="search"
      className="form-control"
      placeholder="Search here"
      style={{ height: "40px", width: "200px" }}
      onInput={(event) => setInputValue(event.target.value)}
    />
  </div>

</div>

        </div>
       <div className="courses-section">
        {spinLoader ? (
    <TableLoader
      rows={5}
      columns={4}
      showHeader={false}
    />
  ) : (
         <table className="courses-table">
            <thead
              className="text-white"
              style={{ backgroundColor: "#8b5cf6" }}
            >
              <tr >
                <th className="center-text">Date</th>
                <th className="center-text">Name</th>

                 <th className="center-text">Job Title</th>
                 <th className="center-text">Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredJobs &&
                filteredJobs.length > 0 &&
                filteredJobs
                  .slice(startIndex, endIndex)
                  .map((appliedJob, i) => (
                    <tr key={i}>
                      <td className="center-text" scope="row">
                        {format(
                          new Date(appliedJob.cnd_permanent_job_created_date),
                          "dd-MM-yyyy"
                        )}
                      </td>
                      <td className="title-cell">
                        {appliedJob.users_firstname +
                          " " +
                          appliedJob.users_lastname}
                      </td>
                      <td className="category-cell">
                        {convertToOriginalForm(
                          appliedJob.cnd_permanent_job_title
                        )}
                      </td>
                       <td className="price-cell">
                        {appliedJob.cnd_permanent_job_status}
                      </td>
                    </tr>
                  ))}
              {appliedJobs.length === 0 ? (
                <tr>
                  <td colSpan="100" className="text-center">
                    No Jobs Found.
                  </td>
                </tr>
              ) : filteredJobs.length === 0 && inputValue ? (
                <tr>
                  <td colSpan="100" className="text-center">
                    No Jobs Found.
                  </td>
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
           )}
        </div>
         <TableNewPaginanation
        totalItems={filteredJobs.length}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChange={(page, size) => {
          setCurrentPage(page);
          if (size !== undefined) setPageSize(size);
        }}
      />
      </div>

     
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    appliedjobs: state.appliedjobs.appliedjobs,
  };
};

export default connect(mapStateToProps)(AppliedJobsList);